import React, {Component} from 'react';
import '../../css/mapstyle.css';
import AreaFilterParent from '../AreaFilterParent/AreaFilterParent';
import MyAreaDropdown from '../MyAreaDropdown/MyAreaDropdown';
import {Indicators, DataInfoPopUp} from 'browse-indicators';
import RouterComponent from '../RouterComponent/RouterComponent';
import {fetchApi} from '../../fetchApi';
import SaveMapPopup from "../SaveMapPopup/SaveMapPopup";
import MoreOptionPopup from "../CommonComponents/MoreOptionPopup";
import ShareMapPopUp from "../CommonComponents/ShareMapPopup";
import {TallModalPopup, ButtonComponent} from "common-components";
import {commitMutation, graphql} from "react-relay";
import environment from "../../RelayEnvironment";
import '../../css/components/MapComponent/Map.css';
import presetPalettes from '../../modules/mapboxgl/shapeStyles.js';
const ellipseVerticalImage = require('../../images/ellipse-vertical.svg');

class MapComponent extends Component {
    constructor(props) {
        super(props);
        if (props.preSavedMap == null) {
            this.state = {
                isSelectIndicatorVisible: false,
                isMapLayersVisible: true,
                isTooltipVisible: false,
                indicatorIdArray: [],
                indicatorOpacityArray: [],
                indicatorPaletteArray: [],
                indicatorCustomPaletteArray: [],
                isPanelHidden: false,
                checkedIndicators: [],
                dataInfoPopUpvisible: true,
                isDataInfoPopupVisible: false,
                maxHeight: "98%"
            }
        }
        else {
            // initialize map using loaded map props if present
            var mapLayers = props.preSavedMap.boardCardUse.configuration.mapLayers.edges;
            var indicatorIdArrayInit = [];
            var indicatorOpacityArrayInit = [];
            var indicatorPaletteArrayInit = [];
            var indicatorCustomPaletteArrayInit = [];
            var checkedIndicatorsInit = [];
            var summaryLevelCodeArrayInit = [];
            for (var i = 0; i < mapLayers.length; i++) {
                indicatorIdArrayInit.push(mapLayers[i].node.indicator.id);
                indicatorOpacityArrayInit.push(mapLayers[i].node.alpha);
                indicatorPaletteArrayInit.push(mapLayers[i].node.palette);
                indicatorCustomPaletteArrayInit.push(mapLayers[i].node.customPalette);
                if (mapLayers[i].node.isVisible) {
                    checkedIndicatorsInit.push(mapLayers[i].node.indicator.id);
                }
                summaryLevelCodeArrayInit.push(mapLayers[i].node.indicator.geographicUnit.summaryLevelCode);
            }
            this.state = {
                isSelectIndicatorVisible: false,
                isMapLayersVisible: false,
                isTooltipVisible: false,
                indicatorIdArray: indicatorIdArrayInit,
                indicatorOpacityArray: indicatorOpacityArrayInit,
                indicatorPaletteArray: indicatorPaletteArrayInit,
                indicatorCustomPaletteArray: indicatorCustomPaletteArrayInit,
                isPanelHidden: false,
                checkedIndicators: checkedIndicatorsInit,
                summaryLevelCodeArray: summaryLevelCodeArrayInit,
            }
        }
    }

    // Handles when a zoom area (not saved community area) is selected
    handleAreaSelected = (selectedValue) => {
        this.setState({isMapLayersVisible: true});
        this.setState({selectedArea: selectedValue}, this.moveMapToArea);
        this.props.onUnsavedAreaSelected(selectedValue);
    };

    handleSelectIndicator = () => {
        this.setState({isSelectIndicatorVisible: true});
        this.props.closePopups();
    };
    closeSelectIndicator = () => {
        this.setState({isSelectIndicatorVisible: false});
        return true;
    };

    handleMyAreaDropdown = () => {
        if (this.props.globallyVisible === true) {
            return <MyAreaDropdown  {...this.props} isMapLayersVisible={this.state.isMapLayersVisible}
                                    onAreaSelected={this.handleAreaSelected}/>
        }
        else {
            return <div></div>
        }

    };

    handleAreaFilter = () => {
        if (this.props.globallyVisible === true) {
            return <AreaFilterParent
                {...this.props}
                onFilterByAreaChange={this.handleFilterByAreaChange}
                isMapLayersVisible={this.state.isMapLayersVisible}
                onClickMoreButton={this.handleMoreButton}
                indicatorIdArray={this.state.indicatorIdArray}
                disabled={this.props.areaFilterDisabled}
            />
        }
        else {
            return <div></div>
        }
    };

    handleFilterByAreaChange = () => {
        this.props.onFilterByAreaChange();
    };

    handleMoreButton = () => {
        this.props.hideUnHidePopUp(0, 0, "MoreInfo", null);
    };

    handlecheckedIndicators = (indicatorid) => {
        var oldstate = this.state.checkedIndicators;
        var visible = true;
        let mutablecopy = oldstate.slice(0);
        if (mutablecopy.includes(indicatorid)) {
            let position = mutablecopy.indexOf(indicatorid);
            mutablecopy.splice(position, 1);
            this.setState({checkedIndicators: mutablecopy});
            visible = false;
        }
        else {
            mutablecopy.push(indicatorid);
            this.setState({checkedIndicators: mutablecopy})
        }
        let position = this.state.indicatorIdArray.indexOf(indicatorid);
        var updatemapfields = {
            indicatorId: indicatorid,
            visible: visible,
            index: position,
            customPalette: this.state.indicatorCustomPaletteArray[position]
        };
        this.props.onMapLayerUpdate(updatemapfields)
    };

    handleMapLayerPaletteChanged = (indicatorId, palette) => {
        this.props.onMapLayerPaletteChangedOL(indicatorId, palette);
        var position = this.state.indicatorIdArray.indexOf(indicatorId);
        var newPaletteArray = this.state.indicatorPaletteArray.slice(0);
        newPaletteArray[position] = palette;
        var newIndicatorCustomPaletteArray = this.state.indicatorCustomPaletteArray.slice(0);
        newIndicatorCustomPaletteArray[position] = presetPalettes[palette].slice(0);
        this.setState({indicatorPaletteArray: newPaletteArray, 
            indicatorCustomPaletteArray: newIndicatorCustomPaletteArray});
    };

    onMapLayerOpacityChanged = (indicatorId, opacity) => {
        this.props.onMapLayerOpacityChangedOL(indicatorId, opacity);
        var position = this.state.indicatorIdArray.indexOf(indicatorId);
        var newOpacityArray = this.state.indicatorOpacityArray.slice(0);
        newOpacityArray[position] = opacity;
        this.setState({indicatorOpacityArray: newOpacityArray});
    };

    handleMapLayers = () => {
        /*
        if(this.props.embedded === true) {
            return null;
        }
        */
        return (
            <RouterComponent
                routeIndicatorId={this.routeIndicatorId}
                onMapLayerOpacityChanged={this.onMapLayerOpacityChanged}
                onMapLayerPaletteChanged={this.handleMapLayerPaletteChanged}
                {...this.props}
                handleSelectIndicator={this.handleSelectIndicator}
                handleMapLayerGeographyChanged={this.handleIndicatorGeographyChanged}
                indicatorIdArray={this.state.indicatorIdArray}
                indicatorOpacityArray={this.state.indicatorOpacityArray}
                indicatorPaletteArray={this.state.indicatorPaletteArray}
                indicatorCustomPaletteArray={this.state.indicatorCustomPaletteArray}
                getMapCenterAndZoom={this.props.getMapCenterAndZoom}
                handlecheckedIndicators={this.handlecheckedIndicators}
                checkedIndicators={this.state.checkedIndicators}
                isMapLayersVisible={this.state.isMapLayersVisible}
                dataInfoPopUpvisible={this.state.dataInfoPopUpvisible}
                handleDataInfoPopUpvisible={this.handleDataInfoPopUpvisible}
                onDataInfoPopup={this.DataInfoPopupHandler}
                savedAreaId={this.state.selectedArea}
                isDataInfoPopupVisible={this.state.isDataInfoPopupVisible}
                onCloseDataInfoPopup={this.handleCloseDataInfoPopup}
                mapLayersUpdate={this.mapLayersUpdate}
            />);
    };

    moveMapToArea = async () => {
        if (this.state.selectedArea == null) {
            return null;
        }
        var variables;
        if (this.state.selectedArea.geographicUnit != null) {
            variables = {"input": {"geoId": this.state.selectedArea.value}};
        } else {
            /* if(this.state.selectedArea.geographicUnit != null) */
            variables = {"input": {"savedAreaId": this.state.selectedArea.value}};
        }
        let formdata = {
            "query": `
      query MapAreaMoveQuery($input: AreaShapesInput!) {
        areaMove(area: $input) {
            mapCenterLat
            mapCenterLng
            mapExtent
        }
      }      
    `, "variables": variables
        };
        let response = await fetchApi("graphql", JSON.stringify(formdata));
        var extent = response.data.areaMove.mapExtent;
        this.props.fitMapToExtent(this.state.selectedArea, extent);
    };

    handleSelectIndicator1 = () => {
        if (this.state.isSelectIndicatorVisible === true && this.props.globallyVisible === true) {
            return (<div>
                <Indicators indicatorIdArray={this.state.indicatorIdArray}{...this.props}
                                  closeSelectIndicator={this.closeSelectIndicator}
                                  routeIndicatorId={this.routeIndicatorId} />
            </div>)
        }
        else {
            return <div></div>
        }
    };
    CallhideCarret = () => {
        this.props.hideCarret();
        this.props.closePopups();
        this.setState((prevState) => {
            return {isTooltipVisible: false, isPanelHidden: !prevState.isPanelHidden}
        });

    };
    hidetooltip = () => {
        this.setState({isTooltipVisible: false});
    };
    showtooltip = () => {
        this.setState({isTooltipVisible: true});
    };
    // IMPORTANT: handles adding an indicator layer to the map
    routeIndicatorId = (indicatorid, summaryLevelCode) => {

        var oldstate = this.state.indicatorIdArray;
        var mutablecopy = oldstate.slice(0);
        // console.log("intial value of the indicatorIdArray",this.state.indicatorIdArray)
        if (mutablecopy.includes(indicatorid) === true) {
            // console.log("remove indicator ", indicatorid);
            var position = mutablecopy.indexOf(indicatorid);
            mutablecopy.splice(position, 1);
            var newOpacityArray = this.state.indicatorOpacityArray.slice(0);
            newOpacityArray.splice(position, 1);
            var newPaletteArray = this.state.indicatorPaletteArray.slice(0);
            newPaletteArray.splice(position, 1);
            var newCustomPaletteArray = this.state.indicatorCustomPaletteArray.slice(0);
            newCustomPaletteArray.splice(presetPalettes[position].slice(0), 1);
            if (this.state.checkedIndicators.includes(indicatorid) === true) {
                var newCheckedArray = this.state.checkedIndicators.slice(0);
                position = newCheckedArray.indexOf(indicatorid);
                newCheckedArray.splice(position, 1);
                this.setState({
                        indicatorIdArray: mutablecopy,
                        checkedIndicators: newCheckedArray,
                        indicatorOpacityArray: newOpacityArray,
                        indicatorPaletteArray: newPaletteArray,
                        indicatorCustomPaletteArray: newCustomPaletteArray
                    },
                    this.updateAllMapLayerPositions);
            } else {
                this.setState({
                        indicatorIdArray: mutablecopy,
                        indicatorOpacityArray: newOpacityArray,
                        indicatorPaletteArray: newPaletteArray,
                        indicatorCustomPaletteArray: newCustomPaletteArray
                    },
                    this.updateAllMapLayerPositions);
            }
            this.props.handleMapLayerRemoved(indicatorid);
        }
        else {
            // console.log("add indicator ", indicatorid);
            var newArray = mutablecopy.concat(indicatorid);
            newOpacityArray = this.state.indicatorOpacityArray.concat(1.0);
            var newPaletteIndex = (newArray.length - 1) % 6;
            newPaletteArray = this.state.indicatorPaletteArray.concat(newPaletteIndex);
            newCustomPaletteArray = this.state.indicatorCustomPaletteArray.concat([presetPalettes[newPaletteIndex].slice(0)]);
            // start the first indicator layer added as visible on map
            if (this.state.indicatorIdArray.length === 0) {
                this.setState({
                    indicatorIdArray: newArray,
                    checkedIndicators: [indicatorid],
                    indicatorOpacityArray: newOpacityArray,
                    indicatorPaletteArray: newPaletteArray,
                    indicatorCustomPaletteArray: newCustomPaletteArray
                });
                var updatemapfields = {
                    indicatorId: indicatorid,
                    summaryLevelCode: summaryLevelCode,
                    visible: true,
                    index: (newArray.length - 1),
                    opacity: 1.0,
                    paletteIndex: newPaletteArray[newArray.length - 1],
                    customPalette: newCustomPaletteArray[newCustomPaletteArray.length - 1]
                };
                this.props.onMapLayerUpdate(updatemapfields);
            }
            else {
                this.setState({
                    indicatorIdArray: newArray,
                    indicatorOpacityArray: newOpacityArray,
                    indicatorPaletteArray: newPaletteArray,
                    indicatorCustomPaletteArray: newCustomPaletteArray
                });
                updatemapfields = {
                    indicatorId: indicatorid,
                    summaryLevelCode: summaryLevelCode,
                    visible: false,
                    index: (newArray.length - 1),
                    opacity: 1.0,
                    paletteIndex: newPaletteArray[newArray.length - 1],
                    customPalette: newCustomPaletteArray[newCustomPaletteArray.length - 1]
                };
                this.props.onMapLayerUpdate(updatemapfields);
            }

        }
    };
    handleIndicatorGeographyChanged = (oldIndicatorId, newIndicatorId, newSummaryLevelCode) => {
        var oldstate = this.state.indicatorIdArray
        var mutablecopy = oldstate.slice(0)
        // console.log("intial value of the indicatorIdArray",this.state.indicatorIdArray)
        if (mutablecopy.includes(oldIndicatorId) === true) {
            //console.log("replace indicator ", oldIndicatorId);
            var position = mutablecopy.indexOf(oldIndicatorId)
            mutablecopy.splice(position, 1, newIndicatorId)
            var newCheckedArray = this.state.checkedIndicators.slice(0);
            if (this.state.checkedIndicators.includes(oldIndicatorId) === true) {
                position = newCheckedArray.indexOf(oldIndicatorId);
                newCheckedArray.splice(position, 1, newIndicatorId);
            }
            this.setState({indicatorIdArray: mutablecopy, checkedIndicators: newCheckedArray});
            //this.props.handleMapLayerRemoved(indicatorid);
            this.props.handleMapLayerGeographyChangedOL(oldIndicatorId, newIndicatorId, newSummaryLevelCode);
        }
    }

    componentWillUnmount() {
        console.log("Map root unmounting");
        // save map state (if logging in/switching user accounts) and remove map
        this.props.removeMap();
    }

    componentDidMount() {
        // create Mapbox GL map object and link to DOM
        if (this.props.urlParameters != null && this.props.urlParameters.mapCardIdToLoad != null) {
            console.log("show map layers for loading map:", this.props.urlParameters);
            // add map layers to Mapbox GL map object after map linked to DOM
            var mapLayerUpdateObjects = [];
            var includesCountyData = false;
            for (var i = 0; i < this.state.indicatorIdArray.length; i++) {
                let updatemapfields = {
                    indicatorId: this.state.indicatorIdArray[i],
                    summaryLevelCode: this.state.summaryLevelCodeArray[i],
                    visible: this.state.checkedIndicators.includes(this.state.indicatorIdArray[i]),
                    index: i,
                    opacity: this.state.indicatorOpacityArray[i],
                    palette: this.state.indicatorPaletteArray[i],
                    paletteIndex: this.state.indicatorPaletteArray[i],
                    customPalette: this.state.indicatorCustomPaletteArray[i]
                };
                if(this.state.summaryLevelCodeArray[i] === '050') {
                    includesCountyData = true;
                }
                mapLayerUpdateObjects.push(updatemapfields);
            }
            this.props.setPreloadedIndicatorLayers(mapLayerUpdateObjects);
            this.setState({isMapLayersVisible: true});
            let mapConfiguration = this.props.preSavedMap.boardCardUse.configuration;
            let callback = null;
            let countiesoutlines = (this.props.embedded === true) || (includesCountyData === true);
            let is_embedded_map = this.props.embedded === true;
            this.props.renderMap(mapConfiguration.mapZoom,
                mapConfiguration.mapCenterLng, mapConfiguration.mapCenterLat,
                this.props.urlParameters.mapBaseStyleToLoad, callback, 
                countiesoutlines, is_embedded_map);
        }
        else {
            const {match} = this.props;
            // set indicator once map is fully rendered
            var addSingleIndicator = () => {
                //this.routeIndicatorId("U2VhcmNoYWJsZUluZGljYXRvck5vZGU6MjU2MQ==", "050");
                if (match && match.params.areaid === "indicator" && match.params.id) {
                    this.routeIndicatorId(match.params.id, match.params.summaryLevelCode);
                }
            }

            // default zoom, longitude, latitude for empty map
            if (this.props.urlParameters != null) {
                this.props.renderMap(2.2, -98.585522, 39.8333333, this.props.urlParameters.mapBaseStyleToLoad, addSingleIndicator);
            }
            else {
                this.props.renderMap(2.2, -98.585522, 39.8333333, null, addSingleIndicator);
            }
        }

        //console.log(this.props.getMapCenterAndZoom());
    }

    handleCloseisSaveMapPopUpVisible = () => {
        this.setState({isDownloadMapPopUpVisible: false})
        this.setState({isSaveMapPopUpVisible: false})
        this.setState({isShareMapPopUpVisible: false})
        this.setState({dataInfoPopUpvisible: false})
    }
    handleDataInfoPopUpvisible = () => {
        this.setState({dataInfoPopUpvisible: true})
    }

    updateAllMapLayerPositions = () => {
        // tell OpenLayers to update z-index on all layers
        for (var i = 0; i < this.state.indicatorIdArray.length; i++) {
            console.log("updateAllMapLayerPositions", this.state.indicatorIdArray[i], i);
            this.props.handleMapLayerPositionChanged(
                this.state.indicatorIdArray[i], i);
        }
    };

    handleCloseMapPopup = () => {
        this.props.history.replace({ ...this.props.history.location, hash: null});
        this.props.closePopups();
        if(this.props.isMorePopUpVisible === true) {
            this.props.hideUnHidePopUp(0, 0, "MoreInfo", null);
        }
    };

    closeShareMapPopup = () => {
        this.props.closePopups();
        if(this.props.isMorePopUpVisible === true) {
            this.props.hideUnHidePopUp(0, 0, "MoreInfo", null);
        }
    };

    goBack = () => {
        if (this.props.history && this.props.history.location &&  this.props.history.location.hash){
            this.props.history.goBack()
        } else {
            this.handleCloseMapPopup();
        }
    };

    handleSaveMapPopup = () => {
        if (this.props.globallyVisible === true && this.props.isSaveMapPopUpVisible === true) {
            var indicatorsObjectArray = this.state.indicatorIdArray.map((id, j) => {
                return {
                    id,
                    position: j,
                    palette: this.state.indicatorPaletteArray[j],
                    customPalette: this.state.indicatorCustomPaletteArray[j],
                    alpha: this.state.indicatorOpacityArray[j],
                    isVisible: this.state.checkedIndicators.includes(id)
                };
            });
            const {history: {location}} = this.props;
            return <TallModalPopup closePopUp={this.handleCloseMapPopup}
                                   goBack={(location && location.hash && location.hash === "#save") ? this.handleCloseMapPopup : this.goBack}>
                        <SaveMapPopup {...this.props}
                                     getMapCenterAndZoom={this.props.getMapCenterAndZoom}
                                     getMapPngUrl={this.props.getMapPngUrl}
                                     indicatorsObjectArray={indicatorsObjectArray}
                                     handleCloseMapPopup={this.handleCloseMapPopup}
                                     savedAreaId={this.state.selectedArea}
                                     centerAndzoom={this.props.centerAndzoom}/>
                    </TallModalPopup>
        }
        else {

            return <div></div>
        }

    }

    handleShareMapPopup = () => {
        if (this.props.isShareMapPopUpVisible === true && this.props.globallyVisible === true) {

            // upload map data via mutation, use return value to download png
            this.closeShareMapPopup()
            if(this.state.savingInProgress===true) {
                return;
            }
            this.setState({savingInProgress:true});

            const mutation = graphql`
                mutation MapExportMutation($input: CreateMapCardInput!) {
                    createMapCard(input: $input) {
                        mapImageUrl
                    }
                }
                `;
            const pngUrl = this.props.getMapPngUrl();

            var indicatorsObjectArray = this.state.indicatorIdArray.map((id, j) => {
                return {
                    id,
                    position: j,
                    palette: this.state.indicatorPaletteArray[j],
                    customPalette: this.state.indicatorCustomPaletteArray[j],
                    alpha: this.state.indicatorOpacityArray[j],
                    isVisible: this.state.checkedIndicators.includes(id)
                };
            });


            const variables = {
                "input": {
                    "indicators": indicatorsObjectArray,
                    "mapImageOnly": true,
                    "name": "Map Download",
                    "notes": this.state.notes,
                    "thumbnailImage": pngUrl
                }
            };
            //console.log("input values for save map",JSON.stringify(variables))

            // TODO: add error handling and better responsive progress dialogue
            commitMutation(
                environment,
                {
                    mutation,
                    variables,
                    onCompleted: (response, errors) => {
                        console.log('Response received from server.');
                        this.setState({savingInProgress:false});
                        // TODO: download the file at mapImageUrl
                        console.log(response.createMapCard.mapImageUrl);
                        window.location.assign(response.createMapCard.mapImageUrl);
                        this.closeShareMapPopup();
                    },
                    onError: (err) => {
                        console.error(err);
                        alert('Error downloading map');
                        this.setState({savingInProgress:false});
                        this.closeShareMapPopup();
                    },
                },
            );
        }
        else {

            return <div></div>
        }

    };

    handleCloseDataInfoPopup = () => {
        this.setState({isDataInfoPopupVisible:false});
    }

    mapLayersUpdate = (mapLayersHeight) => {
        if (mapLayersHeight <= 480) {
            this.setState({maxHeight: mapLayersHeight + 285})
        } else {
            this.setState({maxHeight: "98%"})
        }
    };

    DataInfoPopupHandler = (indicatorId) => {
        this.setState({isDataInfoPopupVisible:true, dataInfoPopupIndicatorId:indicatorId}, () => {
            this.props.closePopups();
            this.handleDataInfoPopUpvisible();
        });
    }

    handleDataInfoPopup = () => {
        if (this.state.isDataInfoPopupVisible && this.props.globallyVisible && this.state.dataInfoPopUpvisible) {

            return <DataInfoPopUp
                dataInfoPopupIndicatorId={this.state.dataInfoPopupIndicatorId}
                closePopUp={this.closeDataInfoPopup}
                history={this.props.history}
            />

        }
        else {

            return <div></div>
        }

    }

    closeDataInfoPopup = () => {
        this.handleCloseDataInfoPopup();
    }

    handleShareModal = () => {
        this.setState({showShareModal: true},
            () => { this.props.history.replace({ ...this.props.history.location, hash: null}) })
        if(this.props.isMorePopUpVisible === true) {
            this.props.hideUnHidePopUp(0, 0, "MoreInfo", null);
        }
    };

    handleDownloadModal = () => {
        this.setState({showShareModal: true},
            () => { this.props.history.replace({ ...this.props.history.location, hash: "download"}) })
    };

    closeShareModal = () => {
        this.props.history.replace({ ...this.props.history.location, hash: null});
        this.setState({showShareModal: false});
        this.props.closePopups();
    };

    onExportMap = () => {
        this.setState({showShareModal: false}, () => {
            this.props.history.replace({ ...this.props.history.location, hash: null});
            this.props.onExportMap();
        });
    };

    render() {
        const { globallyVisible, getMapCenterAndZoom, savedAreaIdSelected, getMapPngUrl, filterByArea, onExportMap } = this.props;
        const { showShareModal, indicatorIdArray, indicatorPaletteArray, 
            indicatorCustomPaletteArray } = this.state;

        var indicatorsObjectArray = this.state.indicatorIdArray.map((id, j) => {
            return {
                id,
                position: j,
                palette: indicatorPaletteArray[j],
                customPalette: indicatorCustomPaletteArray[j],
                alpha: this.state.indicatorOpacityArray[j],
                isVisible: this.state.checkedIndicators.includes(id)
            };
        });
        return (
            <div className={"test " + ((indicatorIdArray.length > 0 && globallyVisible) ? "h-100" : "")}
                 style={{
                     overflow: "hidden",
                     maxHeight: this.state.maxHeight,
                     height: (indicatorIdArray.length > 0 && globallyVisible) ? "" : "300px"
                 }}
                 onClick={() => this.props.hidePopUp()}>
                <div className={"map-wrapper text-left " + ((indicatorIdArray.length > 0 && globallyVisible) ? "h-100" : "")}> {/* style={{height: window.innerHeight}} */}
                    <div id="map" onClick={this.handleCloseisSaveMapPopUpVisible} tabIndex="1">
                    </div>
                    <div className={"map-contener " +
                        ((indicatorIdArray.length > 0 && globallyVisible) ? "h-100" : "") +
                        (globallyVisible ? " map-contener-width" : " d-inline-block")}>
                        <div className={"map-title-wrap " + (globallyVisible ? "" : "d-inline-block")}>
                            <div className={"map-search-wrapper p-3 " + (globallyVisible ? "" : "d-inline-block")}>
                                <div>
                                    <span className={globallyVisible ? "tooltip-custom rotatearrow" : ""}
                                          onMouseOver={this.showtooltip} onMouseOut={this.hidetooltip}
                                    >
                                        <h4 onClick={this.CallhideCarret}
                                         className="onhover-tooltip">Map Room <span></span>
                                        </h4>
                                        {this.state.isTooltipVisible === true ? (this.state.isPanelHidden ?
                                            <span className="show-tooltip-custom tooltip-show-panel">Show Panel</span> :
                                            <span className="show-tooltip-custom tooltip-hide-panel">Hide Panel</span>) : null}
                                    </span>
                                    {globallyVisible &&
                                        <div className="areaFilterParent-morebutton">
                                            <ButtonComponent
                                                buttonType="outlined"
                                                buttonTitle="Share"
                                                iconClass='share-icon'
                                                onClick={this.handleShareModal} />
                                            <img src={ellipseVerticalImage} width={20} height={20}
                                                 alt=""
                                                 onClick={this.handleMoreButton}/>
                                            {this.props.isMorePopUpVisible &&
                                                <MoreOptionPopup
                                                    hidePopUp={this.props.hidePopUp}
                                                    isVisible={true}
                                                    x={this.props.xOriginForMorePopUp}
                                                    y={this.props.yOriginForMorePopUp}
                                                    onSelectArea={this.props.onSelectArea}
                                                    onMaskToggle={this.props.onMaskToggle}
                                                    onSaveMap={this.props.onSaveMap}
                                                    onExportMap={onExportMap}
                                                    onDownloadMenu={this.handleDownloadModal}
                                                    onDownloadData={this.props.onDownloadData}
                                                    indicatorIdArray={indicatorIdArray}
                                                    savedAreaIdSelected={savedAreaIdSelected}
                                                    filterByArea={filterByArea}
                                                />
                                            }
                                        </div>
                                    }
                                </div>
                                {globallyVisible &&
                                    <div className="pt-4">
                                        {this.handleMyAreaDropdown()}
                                        {this.handleAreaFilter()}
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="map-contener-search-wrap">
                            {this.handleMapLayers()}
                        </div>
                    </div>
                    {this.handleSelectIndicator1()}
                    {this.handleSaveMapPopup()}
                    {this.handleShareMapPopup()}
                    {this.handleDataInfoPopup()}
                    {showShareModal &&
                        <ShareMapPopUp closePopUp={this.closeShareModal}
                                       getMapCenterAndZoom={getMapCenterAndZoom}
                                       savedAreaIdSelected={savedAreaIdSelected}
                                       indicatorsObjectArray={indicatorsObjectArray}
                                       getMapPngUrl={getMapPngUrl}
                                       fromShare={true}
                                       onDownloadData={this.props.onDownloadData}
                                       handleSaveMap={this.handleSaveMap}
                                       indicatorIdArray={indicatorIdArray}
                                       filterByArea={filterByArea}
                                       onExportMap={this.onExportMap}
                                       history={this.props.history} />
                    }
                    <a href="https://learn.broadstreet.io/" target="_blank" rel="noopener"><span className="map-icon new"></span></a>
                    {this.props.embedded === true && 
                    <span className="map-notes-overlay">Map by <a href="https://learn.broadstreet.io" target="_blank" rel="noopener">BroadStreet.io</a>. BroadStreet updates data regularly. Last update 4/23/2020 23:30 CDT.  <a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a></span>
                    }
                </div>
            </div>
        )
    }
}

export default MapComponent;












// WEBPACK FOOTER //
// ./src/components/MapComponent/Map.js